import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loginTelegram, logout, resetState } from '@/actions';

const useSeamlessLogin = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const isLoginFailed = useSelector(state => state.auth.isLoginFailed);

  const [telegramUser, setTelegramUser] = useState(auth.user);
  const [loginAttemptMade, setLoginAttemptMade] = useState(false);
  const [loggedIn, setLoggedIn] = useState(!!auth.user);

  const isSeamlessLogin = searchParams.has('id') && searchParams.has('hash');
  const userIdToLogin = isSeamlessLogin ? parseInt(searchParams.get('id')) : 0;

  const isLoggedIn = !!auth?.user;
  const userIdLoggedIn = auth?.user?.telegramUserId;

  const preLoggedIn =
    isLoggedIn &&
    (!isSeamlessLogin || (isSeamlessLogin && userIdLoggedIn === userIdToLogin));

  const onLogin = (telegramUser, isAttempt = true, requestId) => {
    if (isAttempt) {
      setLoginAttemptMade(true);
    }
    setLoggedIn(true);
    dispatch(loginTelegram({ ...telegramUser, requestId }));
  };

  const onLogout = () => {
    setLoggedIn(false);
    dispatch(logout());
    window.location.reload(false);
  };

  useEffect(() => {
    if (isSeamlessLogin && !loginAttemptMade) {
      // Only reset state if trying to login as a different user
      if (auth.user && auth.user.telegramUserId !== parseInt(searchParams.get('id'))) {
        dispatch(resetState());
      }

      onLogin(
        {
          id: searchParams.get('id'),
          first_name: searchParams.get('first_name'),
          last_name: searchParams.get('last_name'),
          username: searchParams.get('username'),
          photo_url: searchParams.get('photo_url'),
          auth_date: searchParams.get('auth_date'),
          hash: searchParams.get('hash'),
        }
      );
    }
  }, []);

  return {
    telegramUser,
    loggedIn,
    loginAttemptMade,
    isSeamlessLogin,
    preLoggedIn,
    onLogin,
    onLogout,
    isLoginFailed,
  };
};

export default useSeamlessLogin;
